module.exports = __webpack_public_path__ + "media/images/default-812ec5ed.png";